var site = site || {};
(function ($) {
  site.EDD = site.EDD || {};

  site.EDD.whenWillMyOrderArrive = function(args) {
      $('.order_arrival #order_arrival_info a').hide();
      if( generic.cookie("LOCALE") == "en_US" ) {
          if(args.isShoppable) {
              $('.order_arrival #order_arrival_info a').show();
          }
      }
      var get_edd = $('#order_arrival_info a');
      if(get_edd.length > 0 && get_edd[0].hasAttribute("data-loaded")) {
          return;
      }
      get_edd.on("click", function(e) {
          e.preventDefault();
          $('.order_delivery_info .header, .order_delivery_info .body').hide();
          $('.invalid_zipcode').addClass('hidden');
          $('.content_with_zipcode').addClass('hidden');
          $('.content_without_zipcode').removeClass('hidden');
          generic.overlay.launch({
              content: $('.order_arrival_details_overlay').html(),
              includeBackground: true,
              cssClass: 'edd_popover',
              lockPosition: true,
              center: true, // one line required set
          });
      });
      $('.order_arrival_details .postal_code .apply').on("click", function(e) {
          e.preventDefault();
          site.EDD.showOrderArrivalDate();
      });

      $('.order_arrival_details .postal_code #zipcode').on('keyup blur', function() {
          $(this).val($(this).val().replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, ''));
      });

      $('.order_arrival_details .postal_code #zipcode').on('focus',function() {
        if ($(this).attr('placeholder') == $(this).val()) {
          $(this).val('');
        }
      });

      $('.order_arrival_details .postal_code #zipcode').on('focusout',function() {
        if ($(this).val().trim() == '') {
          var placeholder = $(this).attr('placeholder');
          $(this).val(placeholder);
        }
      });
      get_edd.attr("data-loaded", "1");
  };

  site.EDD.showOrderArrivalDate = function(args) {
      var ctrlZipcode = $('.edd_popover .order_arrival_details .postal_code #zipcode');
      var zipcode = ctrlZipcode.val();
      var watermark = ctrlZipcode.attr("placeholder");

      if (zipcode == watermark) { //IE8 Fix: Placeholder is not supported
          zipcode = '';
      }
      generic.jsonrpc.fetch({
          method: 'address.estimateDeliveryDateSPP_v2',
          params: [{
              "POSTAL_CODE": zipcode
          }],
          onSuccess: function(jsonRpcResponse) {
              var body = $('.order_arrival_details .order_delivery_info .body');
              body.html("");
              body.hide();
              $('.order_delivery_info .header').show();
              var arrival_info = jsonRpcResponse.getValue();

              //arrival_info[0].using_zipcode
              var isValidZip = arrival_info[1].is_valid_zipcode;
              if (isValidZip) {
                  $('.order_delivery_info').addClass('valid_zipcode');
                  $('.invalid_zipcode').addClass('hidden');
                  $('#colorbox').removeClass('empty_zipcode').addClass('zipcode');
                  $('.content_with_zipcode').removeClass('hidden');
                  $('.content_without_zipcode').addClass('hidden');
              } else {
                  $('.invalid_zipcode').removeClass('hidden');
                  $('.order_delivery_info').removeClass('valid_zipcode');
                  $('#colorbox').addClass('empty_zipcode').removeClass('zipcode');
                  $('.content_with_zipcode').addClass('hidden');
                  $('.content_without_zipcode').removeClass('hidden');
              }
              //Sorting shipment type as per spec
              var display_order = ["us_nextday", "us_2day", "us_std", "us_std_exact", "us_territory", "us_mil_pobox"];
              for (iCnt = 0; iCnt < display_order.length; iCnt++) {
                  for (jCnt = 2; jCnt < arrival_info.length; jCnt++) {
                      if (arrival_info[jCnt].type == display_order[iCnt]) {
                          arrival_info[jCnt].shipment_type = $('.' + arrival_info[jCnt].type).text();
                          arrival_info[jCnt].arrival_date = arrival_info[jCnt].min_day_name + " " +
                              arrival_info[jCnt].min_mon + "/" +
                              arrival_info[jCnt].min_day_num;

                          if (arrival_info[jCnt].max_day_name) {
                              arrival_info[jCnt].arrival_date += " - " + arrival_info[jCnt].max_day_name + " " +
                              arrival_info[jCnt].max_mon + "/" +
                              arrival_info[jCnt].max_day_num;
                          }

                          generic.template.get({
                              path: '/sites/esteelauder/modules/custom/esteelauder_product/templates/_partials/product_edd_v2/estimated_delivery_date.mustache',
                              object: arrival_info[jCnt],
                              callback: function(html) {
                                  body.append(html);
                              }
                          });
                          break;
                      }
                  }
              }
              body.show();
          },
          onFailure: function(jsonRpcResponse) {
              //console.log(jsonRpcResponse.getError());
              console.log('Failed to get zip code information');
          }
      });
  };
})(jQuery);


